import styled from 'styled-components'
import { Box } from '../../Box'
import { Page } from '../../PageLayout'
import { colors } from '../../_styles/colors'
import { spacing } from '../../_styles/spacing'

export const StyledPageHeader = styled(Page.Header)<{
  /** The container wants to have equal padding around it,
   * however some cases, like Tabs, do no want that padding. */
  $hasPaddingBottom: boolean
}>`
  border-bottom: 1px solid ${colors.gray85};
  padding-top: ${spacing.lg}px;
  ${(p) => p.$hasPaddingBottom && `padding-bottom: ${spacing.lg}px;`}
`

export const StyledActions = styled(Box)`
  width: fit-content;
`

export const StyledToggleActionBox = styled(Box)`
  /** bottom: 10px; is same as top: -10px; (negative value) */
  bottom: ${spacing.lg}px;
  position: relative;
  padding-left: 48px;
`
